export default "__VITE_ASSET__BSWg_Yuh__"